import { render, staticRenderFns } from "./BindUser.vue?vue&type=template&id=2f34fae7&"
import script from "./BindUser.vue?vue&type=script&lang=js&"
export * from "./BindUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BindUser.vue"
export default component.exports